module.exports = __webpack_public_path__ + "static/media/B2.a5ee8d93.jpg";